import { arrayOf, element, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
const FilteredListProperties = {
    children: {
        type: oneOfType([element, arrayOf(element)]).notEnumerable(),
    },
    uuid: {
        defaultValue: '',
        type: string,
    },
};
export { FilteredListProperties, };
//# sourceMappingURL=filtered-list-types.js.map